import React, { createContext, ReactNode, useCallback, useState } from "react";

const TabsContext = createContext<any>({});

interface Props {
    children?: ReactNode,
}

const TabsContextProvider = ({children}: Props) => {
    const [tabValueState, setTabValueState] = useState(0);
    const [badgesState, setBadgesState] = useState<Record<string, string | undefined>>({});
    const changeTab = useCallback((event: React.SyntheticEvent, newTabValue: number) => setTabValueState(newTabValue), [setTabValueState]);

    const setBadge = useCallback((type: string, color: "default" | "secondary" | "primary" | "error" | "info" | "success" | "warning" | undefined) => {
        setBadgesState(prevState => {
            return {...prevState, [type]: color};
        })
    }, []);

    const getBadge = useCallback((type: string) => {
        return badgesState[type];
    }, [badgesState]);

    return (
        <TabsContext.Provider
            value={{
                tabValue: tabValueState,
                changeTab: changeTab,
                setBadge: setBadge,
                getBadge: getBadge,
            }}
        >
            {children}
        </TabsContext.Provider>
    );
};

export { TabsContext, TabsContextProvider };